"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var INPUT_SIZES = Object.freeze({
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm,
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg
});
exports.INPUT_SIZES = INPUT_SIZES;